import SimpleBar from 'simplebar'
import './explicit-consent.min.js'

function hasGoogleMaps() {
	return typeof window.google !== 'undefined' && typeof window.google.maps !== 'undefined'
}

function getSearchForm(element) {
	return $(element).closest('form, .form--retailer, .form--contacts')
}

function getContactsTarget(form) {
	var siblingContactsTarget = form.closest('section').nextAll('.footer--contacts').first()

	if (siblingContactsTarget.length) {
		return siblingContactsTarget
	}

	return $('.footer--contacts').first()
}

function getRetailerListContainer() {
	return $('.list--retailer .simplebar-content').length ? $('.list--retailer .simplebar-content') : $('.list--retailer')
}

function ensureRetailerScrollbar() {
	var listElement = $('.section--map .scroll')[0]

	if (listElement === undefined) {
		return
	}

	if (window.retailerScrollbar === undefined) {
		window.retailerScrollbar = new SimpleBar(listElement, { autoHide: false })
		return
	}

	window.retailerScrollbar.recalculate()
}

function scrollRetailerIntoView(retailer) {
	var container = $('.list--retailer .simplebar-content-wrapper')[0]

	if (container === undefined) {
		return
	}

	var prevLi = retailer.prevAll()
	var scrolloffset = 0
	$.each(prevLi, function () {
		scrolloffset += $(this).outerHeight()
	})

	scrollToEl(scrolloffset - 25)
}

function toggleRetailerItem(retailer) {
	$('.list--retailer li').not(retailer).removeClass('item--isopen').find('.more').stop().slideUp()
	retailer.addClass('item--isopen').find('.more').stop().slideDown()
	scrollRetailerIntoView(retailer)
}

function bindRetailerListEvents(markers = []) {
	$('.list--retailer li').off('click').on('click', function (e) {
		var markerID = $(this).attr('data-marker')
		var currentRetailer = $(this)

		if ($(e.target).hasClass('retailer-page-link')) {
			var topCategory = 'Artikel'
			if (window.location.href.indexOf('/artikel/') !== -1) {
				const urlParts = window.location.href.split('/')
				if (urlParts !== null) {
					topCategory = urlParts[4]
					topCategory = topCategory.charAt(0).toUpperCase() + topCategory.slice(1)
				}
			}

			dataLayer.push({
				topCategory: topCategory,
			})
		}

		if (markers[markerID] !== undefined && hasGoogleMaps()) {
			google.maps.event.trigger(markers[markerID], 'click')
			return
		}

		toggleRetailerItem(currentRetailer)
	})
}

function renderRetailerList(locations, markers = []) {
	ensureRetailerScrollbar()

	var listContainer = getRetailerListContainer()
	listContainer.html('')

	for (var i = 0; i < locations.length; i++) {
		var title = locations[i][2] !== undefined ? locations[i][2] : ''
		var add = locations[i][3] !== undefined ? locations[i][3] : ''
		var route = locations[i][4] !== undefined ? locations[i][4] : ''
		var more = locations[i][5] !== undefined ? locations[i][5] : ''
		var text = locations[i][6] !== undefined ? locations[i][6] : ''
		var routeMarkup = ''

		if (route) {
			routeMarkup = '<a class="route" target="_blank" href="' + route + '">' + text + '</a>'
		}

		listContainer.append(
			'<li data-marker="' +
				i +
				'"><h3>' +
				title +
				'</h3>' +
				add +
				routeMarkup +
				more +
				'<i class="icon icon--pin" aria-hidden="true"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-icon-pin"></use></svg></i><i class="icon icon--arrow-acc" aria-hidden="true"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-icon-arrow-acc"></use></svg></i></li>'
		)
	}

	bindRetailerListEvents(markers)
	ensureRetailerScrollbar()
}

///Google map
function setMarkers(map, locations, drive = false, bounds = undefined) {
	var markers = []
	var i

	const icon = {
		path: 'M15.5,1c-8.3,0-15,6.7-15,15c0,5.5,4.8,12.6,14.5,21.5l0.5,0.4l0.5-0.4c9.8-9,14.5-16,14.5-21.5 C30.5,7.8,23.8,1,15.5,1z M15.4,22.2c-3.3,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1S18.8,22.2,15.4,22.2z',
		fillColor: '#C8191E',
		fillOpacity: 1,
		anchor: new google.maps.Point(15, 38),
		strokeWeight: 0,
		scale: 1,
	}

	const anchorPoint = new google.maps.Point(15, 38)
	const iconActive = {
		path: 'M15.5,1c-8.3,0-15,6.7-15,15c0,5.5,4.8,12.6,14.5,21.5l0.5,0.4l0.5-0.4c9.8-9,14.5-16,14.5-21.5 C30.5,7.8,23.8,1,15.5,1z M15.4,22.2c-3.3,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1S18.8,22.2,15.4,22.2z',
		fillColor: '#C8191E',
		fillOpacity: 1,
		anchor: anchorPoint,
		strokeWeight: 0,
		scale: 1.6,
	}

	for (i = 0; i < locations.length; i++) {
		var lat = locations[i][0] !== undefined ? locations[i][0] : ''
		var long = locations[i][1] !== undefined ? locations[i][1] : ''
		var title = locations[i][2] !== undefined ? locations[i][2] : ''
		var route = locations[i][4] !== undefined ? locations[i][4] : ''
		var latlngset = new google.maps.LatLng(lat, long)

		if (bounds !== undefined) {
			bounds.extend(latlngset)
		}

		var marker = new google.maps.Marker({
			map: map,
			title: title,
			position: latlngset,
			icon: icon,
		})

		marker.route = route
		marker.metadata = { type: 'point', id: i }
		markers.push(marker)

		if (!drive) {
			google.maps.event.addListener(
				marker,
				'click',
				(function (marker) {
					return function () {
						for (var j = 0; j < markers.length; j++) {
							markers[j].setIcon(icon)
						}
						marker.setIcon(iconActive)
						var markerID = marker.metadata.id
						var currentRetailer = $('.list--retailer li[data-marker="' + markerID + '"]')
						toggleRetailerItem(currentRetailer)
					}
				})(marker)
			)
		} else {
			google.maps.event.addListener(
				marker,
				'click',
				(function (marker) {
					return function () {
						for (var j = 0; j < markers.length; j++) {
							markers[j].setIcon(icon)
						}
						marker.setIcon(iconActive)
						var markerID = marker.metadata.id
						window.open(marker.route, '_blank')
					}
				})(marker)
			)
		}
	}

	if (!drive) {
		renderRetailerList(locations, markers)
	}

	if (locations.length == 1) {
		map.setZoom(16)
	}

	$('.gm-style').removeClass('gm-style')
}

function scrollToEl(scrolloffset) {
	var container = $('.list--retailer .simplebar-content-wrapper')[0]
	if (container !== undefined) {
		container.scrollTo({ top: scrolloffset, behavior: 'smooth' })
	}
}

async function initializeDefaultMap() {
	await waitForConsent()
	if ($('#mapdrive').length) {
		var dlocations = []

		if (typeof driveLocations !== 'undefined' && driveLocations.length > 0) {
			dlocations = driveLocations

			var lat = dlocations[0][0]
			var long = dlocations[0][1]
		}

		var mapStyles = [
			{
				featureType: 'water',
				elementType: 'geometry',
				stylers: [
					{
						color: '#e9e9e9',
					},
					{
						lightness: 17,
					},
				],
			},
			{
				featureType: 'landscape',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f5f5f5',
					},
					{
						lightness: 20,
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 17,
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 29,
					},
					{
						weight: 0.2,
					},
				],
			},
			{
				featureType: 'road.arterial',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 18,
					},
				],
			},
			{
				featureType: 'road.local',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 16,
					},
				],
			},
			{
				featureType: 'poi',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f5f5f5',
					},
					{
						lightness: 21,
					},
				],
			},
			{
				featureType: 'poi.park',
				elementType: 'geometry',
				stylers: [
					{
						color: '#dedede',
					},
					{
						lightness: 21,
					},
				],
			},
			{
				elementType: 'labels.text.stroke',
				stylers: [
					{
						visibility: 'on',
					},
					{
						color: '#ffffff',
					},
					{
						lightness: 16,
					},
				],
			},
			{
				elementType: 'labels.text.fill',
				stylers: [
					{
						saturation: 36,
					},
					{
						color: '#333333',
					},
					{
						lightness: 40,
					},
				],
			},
			{
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'transit',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f2f2f2',
					},
					{
						lightness: 19,
					},
				],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#fefefe',
					},
					{
						lightness: 20,
					},
				],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#fefefe',
					},
					{
						lightness: 17,
					},
					{
						weight: 1.2,
					},
				],
			},
		]

		var mapType = new google.maps.StyledMapType(mapStyles, { name: 'ms' })
		var bounds = new google.maps.LatLngBounds()

		var mapOptions = {
			zoom: 14,
			zoomControl: true,
			scaleControl: true,
			//scrollwheel: true,
			//disableDoubleClickZoom: false,
			//disableDefaultUI:true,
			mapTypeControl: false,
			center: new google.maps.LatLng(lat, long),
			mapTypeControlOptions: {
				mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'ms'],
			},
		}

		var mapdrive = new google.maps.Map(document.getElementById('mapdrive'), mapOptions)
		mapdrive.mapTypes.set('ms', mapType)
		mapdrive.setMapTypeId('ms')

		setMarkers(mapdrive, dlocations, true, bounds)

		if (dlocations.length > 1) {
			mapdrive.fitBounds(bounds)
		}
	}
}

async function initializeSearchMap() {
	await waitForConsent()
	if ($('#map').length) {
		var locations = []
		var lat = 0
		var long = 0

		if (typeof mapLocations !== 'undefined' && mapLocations.length > 0) {
			locations = mapLocations

			lat = locations[0][0]
			long = locations[0][1]
		}

		var showLabels = 'off'

		if ($('#map').parents('.tabs').length) {
			var showLabels = 'on'
		}

		var mapStyles = [
			{
				featureType: 'water',
				elementType: 'geometry',
				stylers: [
					{
						color: '#e9e9e9',
					},
					{
						lightness: 17,
					},
				],
			},
			{
				featureType: 'landscape',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f5f5f5',
					},
					{
						lightness: 20,
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 17,
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 29,
					},
					{
						weight: 0.2,
					},
				],
			},
			{
				featureType: 'road.arterial',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 18,
					},
				],
			},
			{
				featureType: 'road.local',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 16,
					},
				],
			},
			{
				featureType: 'poi',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f5f5f5',
					},
					{
						lightness: 21,
					},
				],
			},
			{
				featureType: 'poi.park',
				elementType: 'geometry',
				stylers: [
					{
						color: '#dedede',
					},
					{
						lightness: 21,
					},
				],
			},
			{
				elementType: 'labels.text.stroke',
				stylers: [
					{
						visibility: 'on',
					},
					{
						color: '#ffffff',
					},
					{
						lightness: 16,
					},
				],
			},
			{
				elementType: 'labels.text.fill',
				stylers: [
					{
						saturation: 36,
					},
					{
						color: '#333333',
					},
					{
						lightness: 40,
					},
				],
			},
			{
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'transit',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f2f2f2',
					},
					{
						lightness: 19,
					},
				],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#fefefe',
					},
					{
						lightness: 20,
					},
				],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#fefefe',
					},
					{
						lightness: 17,
					},
					{
						weight: 1.2,
					},
				],
			},
		]

		var mapType = new google.maps.StyledMapType(mapStyles, { name: 'ms' })
		var bounds = new google.maps.LatLngBounds()

		var mapOptions = {
			zoom: 14,
			zoomControl: true,
			scaleControl: true,
			//scrollwheel: true,
			//disableDoubleClickZoom: false,
			//disableDefaultUI:true,
			mapTypeControl: false,
			center: new google.maps.LatLng(lat, long),
			mapTypeControlOptions: {
				mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'ms'],
			},
		}

		var map = new google.maps.Map(document.getElementById('map'), mapOptions)
		map.mapTypes.set('ms', mapType)
		map.setMapTypeId('ms')

		setMarkers(map, locations, false, bounds)

		if (locations.length > 1) {
			map.fitBounds(bounds)
		}

		ensureRetailerScrollbar()
	}
}

setTimeout(function () {
	initializeDefaultMap()
}, 500)
$('.form--retailer .icon--location').on('click', getGeocoded)

function getGeocoded(event) {
	var form = getSearchForm(event.currentTarget)
	var contactsTarget = getContactsTarget(form)

	if (contactsTarget.length) {
		form.trigger('submit')
		return
	}

	if (!hasGoogleMaps()) {
		alert(form.data('consent-alert-text'))
		return
	}

	if ('geolocation' in navigator) {
		navigator.geolocation.getCurrentPosition(function (position) {
			var geocoder = new google.maps.Geocoder()
			var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
			let city
			geocoder.geocode({ latLng: latlng }, function (results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					if (results[1]) {
						//find country name
						for (var i = 0; i < results[0].address_components.length; i++) {
							for (var b = 0; b < results[0].address_components[i].types.length; b++) {
								//there are different types that might hold a city admin_area_lvl_1 usually does in come cases looking for sublocality type will be more appropriate
								if (results[0].address_components[i].types[b] == 'locality') {
									//this is the object you are looking for
									city = results[0].address_components[i]
									break
								}
							}
						}

						form.find('#city').val(city.long_name)
						form.find('#latitudeValue').val(position.coords.latitude)
						form.find('#longitudeValue').val(position.coords.longitude)
						form.submit()
					} else {
						console.error('No results found')
					}
				} else {
					console.error('Geocoder failed due to: ' + status)
				}
			})
		})
	} else {
		console.error("Browser doesn't support geolocation API")
	}
}

$('.form--retailer').submit(async function (e) {
	var form = $(this)
	var contactsTarget = getContactsTarget(form)

	if (contactsTarget.length) {
		e.preventDefault()
		sendLocationRequest(form)
		return
	}

	e.preventDefault()
	sendLocationRequest(form)
})

function sendLocationRequest(form) {
	var activeForm = form && form.length ? form : $('.form--retailer').first()
	var url = activeForm.data('url')
	var data = activeForm.serialize()
	var contactsTarget = getContactsTarget(activeForm)
	var hasContactsTarget = contactsTarget.length > 0
	window.mapLocations = []

	$.ajax({
		url: url,
		type: 'POST',
		dataType: 'text',
		data: data,
		success: function (data) {
			if (hasContactsTarget) {
				var responseMarkup = $('<div>').append($.parseHTML(data, document, true))
				var contactsMarkup = responseMarkup.find('.footer--contacts .section--contacts').first()

				if (!contactsMarkup.length) {
					contactsMarkup = responseMarkup.find('.section.section--contacts').first()
				}

				if (!contactsMarkup.length) {
					contactsMarkup = responseMarkup.find('.grid-cell--contact').first().closest('.section')
				}

				if (!contactsMarkup.length) {
					contactsTarget.stop(true, true).hide().empty()
					return
				}

				contactsTarget.stop(true, true).hide().html(contactsMarkup.clone()).slideDown()
				if (contactsTarget.find('.section--contacts').length > 0) {
					$('html, body').animate({ scrollTop: contactsTarget.find('.section--contacts').position().top - 125 })
				}
				return
			}

			data = JSON.parse(data)
			if (Array.isArray(data) && data.length > 0) {
				jQuery.each(data, function (i) {
					var url =
						'https://www.google.com/maps/dir/?api=1&destination=' +
						data[i].information.address +
						',' +
						data[i].information.zipcode +
						' ' +
						data[i].information.city
					url = encodeURI(url)
					var websiteMarkup = data[i].information.url
						? '<a target="_blank" class="retailer-page-link" href="' +
							data[i].information.url +
							'">' +
							'Website' +
							'</a><br>'
						: ''
					window.mapLocations.push([
						data[i].lat,
						data[i].lng,
						data[i].name,
						'<p>' +
							data[i].information.address +
							'<br>' +
							data[i].information.zipcode +
							' ' +
							data[i].information.city +
							'</p>',
						url,
						'<p class="more">' + websiteMarkup + data[i].information.phone + '</p>',
						data[i].calcRoute,
					])
				})
			} else {
				window.mapLocations.push([
					activeForm.find('#latitudeValue').val(),
					activeForm.find('#longitudeValue').val(),
					activeForm.find('#city').val(),
					'<p>' + activeForm.data('not-found-text') + '</p>',
					'',
					'',
					'',
				])
			}

			$('.section--map').slideDown()
			$('html, body').animate({ scrollTop: $('.section--map').position().top - 125 })
			if (hasGoogleMaps()) {
				initializeSearchMap()
				return
			}

			renderRetailerList(window.mapLocations)
		},
		error: function (jqXHR, failure, errorThrown) {
			console.log(errorThrown)
			console.log(jqXHR)
		},
	})

	if ($('.form--retailer #city').val() != '') {
		$('.form--retailer #latitudeValue').val('')
		$('.form--retailer #longitudeValue').val('')
	}
}
